module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 1092
 ** module chunks = 0
 **/